import React, { FC } from 'react';
import { css } from '@emotion/core';

import {
  grid,
  gridCompact,
  spaceTopCozy,
  spaceGapRelaxed,
  flex,
  flexDirectionColumn,
  SPACE_MINIMUM,
  spaceGapComfortable,
} from '@/styles';
import { SkeletonHeader } from '@/components/primitive';

type SearchPageSkeletonProps = {
  isCompact?: boolean;
  isExtending?: boolean;
};

const SearchPageSkeleton: FC<SearchPageSkeletonProps> = ({ isCompact, isExtending }) => {
  const cssGrid = isCompact ? gridCompact : grid;
  const cssGap = isCompact ? spaceGapComfortable : spaceGapRelaxed;
  // eslint-disable-next-line no-nested-ternary
  const width = ` ${isExtending ? '100%' : isCompact ? '60%' : '75%'}`;
  const cssWidth = css`
    width: ${width};
  `;
  const cssSpaceTop = isCompact
    ? css`
        margin-top: ${SPACE_MINIMUM * 3}px;
      `
    : spaceTopCozy;
  const skeleton = <SkeletonHeader isCompact={isCompact} />;
  return (
    <div css={[flex, flexDirectionColumn, cssGap, cssWidth]}>
      <div>
        <div
          css={[
            cssGrid,
            css`
              grid-template-columns: 2fr 1fr;
            `,
          ]}
        >
          {skeleton}
        </div>
        <div
          css={[
            cssSpaceTop,
            cssGrid,
            css`
              grid-template-columns: 5fr 1fr;
            `,
          ]}
        >
          {skeleton}
        </div>
      </div>
      <div>
        <div
          css={[
            cssGrid,
            css`
              grid-template-columns: 1fr 5fr;
            `,
          ]}
        >
          {skeleton}
          {skeleton}
        </div>
        <div css={cssSpaceTop}>{skeleton}</div>
      </div>
      {!isCompact && (
        <div>
          <div
            css={[
              cssGrid,
              css`
                grid-template-columns: 4fr 1fr;
              `,
            ]}
          >
            {skeleton}
          </div>
          <div
            css={[
              cssSpaceTop,
              cssGrid,
              css`
                grid-template-columns: 1fr 1fr;
              `,
            ]}
          >
            {skeleton}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchPageSkeleton;
